import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";

function BlogList() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("/blogPosts.json")
      .then((response) => response.json())
      .then((data) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const visible = data.filter((p) => !p.publishDate || new Date(p.publishDate) <= today);
        setPosts(visible);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, []);

  return (
    <div className='bg-[#FFF] py-20 text-black'>
      <Helmet>
        <title>Blog — Allergen Guides for Market Stalls &amp; Street Food | tastebud.ee</title>
        <meta name='description' content="In-depth guides on UK food allergen law, Natasha's Law and practical advice for street food vendors and market stall holders on displaying allergens legally." />
        <link rel='canonical' href='https://tastebud.ee/blog' />
      </Helmet>
      <h1 className='text-2xl mb-4 px-8 font-semibold text-center'>The tastebud.ee blog</h1>
      <p className='text-lg mb-10 px-8 max-w-screen-lg mx-auto text-center'>
        We believe in the importance of highlighting the benefits of displaying allergens clearly and visibly, even for street traders and market stalls. Take a look at the following in-depth articles
        to help understand the importance of this topic more.
      </p>
      <div className='max-w-screen-lg mx-auto text-left'>
        {loading && <div className='px-4'>Loading...</div>}
        {!loading && posts.length === 0 && <div className='px-4'>No posts yet — check back soon.</div>}
        {posts.map((post) => (
          <div key={post.id} className='mb-2'>
            <h2 className='w-full px-2 pb-1 pt-2 text-xl mx-2'>
              <a href={`/blog/${post.id}`}>{post.title}</a>
            </h2>
            <p className='px-2 mx-2'>{post.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default BlogList;
